import { render, staticRenderFns } from "./ChecklistModelActivityDialog.vue?vue&type=template&id=0bfc80a5&"
import script from "./ChecklistModelActivityDialog.vue?vue&type=script&lang=js&"
export * from "./ChecklistModelActivityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports